// must load resize observer polyfill before SharedResizeObserver
import '../resize-observer-polyfill/resize-observer-polyfill.js';

import { SharedResizeObserver } from 'https://esm.archive.org/@internetarchive/shared-resize-observer@^0.2.0';

window.SharedResizeObserver = SharedResizeObserver;

export { SharedResizeObserver as IASharedRO };
